import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FacilitiesService {

  readonly rootUrl = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) { }

  getFacilities(): Observable<any> {
    return this.http.get(this.rootUrl + '/api/Facilities/facilities');
  }

  getModules(facilityId): Observable<any> {
    return this.http.get(this.rootUrl + '/api/Facilities/modules?facilityId=' + facilityId)
  }
}
